import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import 'bulma/css/bulma.min.css';

import { API_config } from '../../config/apiConfig';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    // Credentials from config
    const VALID_EMAIL = API_config.username;
    const VALID_PASSWORD = API_config.password;

    const handleLogin = (e) => {
        e.preventDefault();
        if (email === VALID_EMAIL && password === VALID_PASSWORD) {
            localStorage.setItem('adminAuth', 'true');
            navigate('/admin');
        } else {
            setError('Invalid email or password');
        }
    };

    return (
        <div className="container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
            <div className="box" style={{ width: '400px' }}>
                <h1 className="title has-text-centered">Admin Login</h1>
                {error && <div className="notification is-danger">{error}</div>}
                <form onSubmit={handleLogin}>
                    <div className="field">
                        <label className="label">Email</label>
                        <div className="control">
                            <input
                                className="input"
                                type="email"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                placeholder="e.g. api@api.pl"
                                required
                            />
                        </div>
                    </div>

                    <div className="field">
                        <label className="label">Password</label>
                        <div className="control">
                            <input
                                className="input"
                                type="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                placeholder="********"
                                required
                            />
                        </div>
                    </div>

                    <div className="field">
                        <div className="control">
                            <button className="button is-primary is-fullwidth" type="submit">Login</button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default Login;
